import React from 'react';

import ProductUniquePicker from "./ProductUniquePicker";

/**
 * Immediately below the pictures of mats, prompt the user
 * to select product_uniques for those mats that need them.
 *
 * try these:
 *
 * 2009 Ford F-150, Standard Cab [1 Pc Front]
 * 2016 Bentley Continental GT
 * 2024 Chevy Silverado Double Cab
 */
export default function ProductUniquesSection({lloydCart, callbacks}) {
  let vehicle = lloydCart?.vehicle;

  // a list of LloydCartItem objects (2025: snake_case)
  const fancyItems = getItemsNeedingSelection(lloydCart);

  if (!fancyItems || (fancyItems.length < 1)) {
    // console.log("no items have prod unique options");
    return null;
  }

  return <div className="my-2">
    <h3 className="text-brand-orange">
      To ensure proper fit, we need to know more about your
      <em>{" " + (vehicle?.fullDescription() || 'vehicle')}</em>.
    </h3>

    {
      fancyItems.map(item => <ProductUniquePicker
          key={item.productId}
          cartItem={item}
          callbacks={callbacks}
        />
      )
    }
  </div>
}

function getItemsNeedingSelection(lloydCart) {
  if (lloydCart) {
    return lloydCart.items.toArray(item => item.requiresUniqueSelection());
  }
}

